import { render, staticRenderFns } from "./TabBloodPressureChart.vue?vue&type=template&id=78564165&scoped=true&"
import script from "./TabBloodPressureChart.vue?vue&type=script&lang=js&"
export * from "./TabBloodPressureChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78564165",
  null
  
)

export default component.exports